import styled from "styled-components";

export default styled.div`
  padding: 1rem;
  border-radius: 12px;
  cursor: pointer;

  .group-card-cont {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .group-card-header {
      display: flex;
      align-items: flex-start;
      gap: 1rem;

      .group-card-title {
        display: flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        gap: 0.5rem;

        .group-card-uni {
          display: flex;
          align-items: center;
          justift-content: flex-start;
          gap: 0.3rem;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    padding: 0.75rem;

    .group-card-cont {
      .group-card-header {
        .group-card-title {
          .group-card-uni {
          }
        }
      }
    }
  }
`;
